/** Wrap bare iframes in a 16:9 responsive container (mobile-safe). */
export function wrapResponsiveEmbeds(root) {
    if (!root) return;

    root.querySelectorAll('iframe').forEach((iframe) => {
        if (iframe.closest('.embed-responsive')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'embed-responsive';

        iframe.removeAttribute('width');
        iframe.removeAttribute('height');
        iframe.style.cssText =
            'position:absolute;top:0;left:0;width:100%;height:100%;border:none;border-radius:12px';

        const parent = iframe.parentElement;
        const parentIsParagraph =
            parent?.tagName === 'P'
            && parent.children.length === 1
            && iframe === parent.firstElementChild;

        if (parentIsParagraph) {
            parent.replaceWith(wrapper);
            wrapper.appendChild(iframe);
        } else {
            iframe.parentNode?.insertBefore(wrapper, iframe);
            wrapper.appendChild(iframe);
        }
    });
}

export const EMBED_RESPONSIVE_STYLE = {
    width: '100%',
    maxWidth: '100%',
    margin: '1rem 0',
    position: 'relative',
    paddingBottom: '56.25%',
    height: 0,
    overflow: 'hidden',
};

export const EMBED_IFRAME_STYLE = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none',
    borderRadius: '12px',
};
